import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Stepper, Step, StepLabel, Button, Typography, TextField, Card, CardContent, Grid, FormControl, InputLabel, MenuItem, Select, Container, FormHelperText, StepConnector } from '@material-ui/core';
import styles from "./index.module.scss"
import { nameValidator, IfscValidator, GstValidator, panValidator, accountNoValidator, handleTypeNumber, CapitalizeFirstLetter } from '../../utils/validation';
import { registerUser, fetchCity, fetchUserDetails } from './registrationApi';
import { useHistory } from 'react-router-dom';
import ModalComponent from '../../components/AlertComponent/modal';

const Registration = () => {
    const style = makeStyles({
        select: {
            "&:focus": {
                backgroundColor: "white"
            }
        }
    });
    const classes = style();
    const [activeStep, setActiveStep] = useState(0);
    const [userDetails, setUserDetails] = useState({
        firstName: null,
        listingName:null,
        mobileNo: null,
        shopName: null,
        email: null,
        businessType: null,
        category: null,
        shopNo: null,
        address: null,
        address2: null,
        pincode: null,
        city: null,
        state: null,
        pan: null,
        gstin: null,
        bankName: null,
        accountNumber: null,
        ifsc: null,
        accountName: null,
        showState: true,
        showCity: true
    });
    const [showModal, setShowModal] = useState(false);
    const [errorToDisplay, setErrorToDisplay] = useState({
        msg: null,
        title: null,
        btn1: null,
        btn2: null,
        btn1Handle: null,
        btn2Handle: null,
        path: null
    })
    const [errorMsg, setErrorMsg] = useState({
        firstName: null,
        listingName:null,
        mobileNo: null,
        emailId: null,
        shopName: null,
        email: null,
        businessType: null,
        category: null,
        shopNo: null,
        address: null,
        address2: null,
        pincode: null,
        city: null,
        state: null,
        pan: null,
        gstin: null,
        bankName: null,
        accountNumber: null,
        ifsc: null,
        accountName: null
    });
    let history = useHistory();
    const requestId = JSON.parse(localStorage.getItem('requestId'));

    useEffect(() => {
        if (requestId) {
            getUserDetails();
        }
        else {
            history.replace('/login');
        }
    }, []);

    const getUserDetails = async () => {
        await fetchUserDetails(requestId)
            .then(res => {
                if (res && res.data.status === 'success') {
                    let obj = {
                        firstName: res.data.data.owner_name,
                        listingName:res.data.data.listing_name,
                        mobileNo: res.data.data.mobile_number,
                        shopName: res.data.data.firm_name,
                        email: res.data.data.email,
                        businessType: res.data.data.type,
                        category: res.data.data.category,
                        shopNo: res.data.data.shopNo,
                        address: res.data.data.address,
                        address2: res.data.data.address_line_2,
                        pincode: res.data.data.pincode,
                        city: res.data.data.city,
                        state: res.data.data.state,
                        pan: res.data.data.pan,
                        gstin: res.data.data.gstin,
                        bankName: res.data.data.bank_name,
                        accountNumber: res.data.data.account_no,
                        ifsc: res.data.data.ifsc,
                        accountName: res.data.data.account_holder_name,
                        showState: false,
                        showCity: false
                    }
                    setUserDetails(obj);
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    //function to customize steps
    const QontoConnector = withStyles({
        active: {
            '& $line': {
                borderColor: '#389203',
            },
        },
        completed: {
            '& $line': {
                borderColor: '#389203',
            },
        },
        line: {
            borderColor: '#eaeaf0',
            borderTopWidth: 3,
            borderRadius: 1,
        },
    })(StepConnector);

    //function to define stepper label
    const getSteps = () => {
        return ['Business Details', 'Shop Location', 'KYC and Bank Details'];
    }

    const steps = getSteps();

    //function to handle stepper content
    const getStepContent = (step) => {
        switch (step) {
            case 0:
                return stepComp1();
            case 1:
                return stepComp2();
            case 2:
                return stepComp3();
        }
    }

    //function to handle modal close
    const handleModalClose = () => {
        setShowModal(false);
    }

    //function to handle input changes
    const inputChange = async (e) => {
        let details = { ...userDetails };
        let msg = { ...errorMsg };
        msg[e.target.name] = false;
        details[e.target.name] = e.target.value;
        if (e.target.name === 'pincode' && e.target.value.trim().length === 6) {
            fetchCityState(e.target.value);
        }
        setUserDetails(details);
        setErrorMsg(msg);

    }

    //function to check validations
    const checkValidations = (e) => {
        let msg = { ...errorMsg };
        if (e.target.name === 'shopName' || e.target.name === 'city' || e.target.name === 'state' || e.target.name === 'bankName' || e.target.name === 'accountName'|| e.target.name === 'listingName') {
            let result = nameValidator(e.target.value);
            if (result) {
                let name = e.target.name === 'shopName' ? 'Shop Name' : e.target.name === 'bankName' ? 'Bank Name' : e.target.name === 'accountName' ? 'Account Name' : e.target.name === 'listingName' ? 'Listing Name' :  e.target.name;
                msg[e.target.name] = (result === 'empty') ? `${CapitalizeFirstLetter(name)} is required.` : `Only characters allowed!`;
            }
            else {
                msg[e.target.name] = null;
            }
        }
        else if (e.target.name === 'businessType' || e.target.name === 'category' || e.target.name === 'address' || e.target.name === 'shopNo') {
            let name = e.target.name === 'businessType' ? 'Business Type' : e.target.name === 'shopNo' ? 'Shop No' : e.target.name;

            if (!e.target.value || !e.target.value.trim()) {
                msg[e.target.name] = `${CapitalizeFirstLetter(name)} is required.`;
            }
            else {
                msg[e.target.name] = null;
            }
        }
        else if (e.target.name === 'pincode') {
            if (!e.target.name || !e.target.name.trim()) {
                msg[e.target.name] = `${CapitalizeFirstLetter(e.target.name)} is required.`;
            }
            else {
                msg[e.target.name] = null;
            }
        }
        else if (e.target.name === 'pan') {
            let result = panValidator(e.target.value);
            if (result) {
                msg[e.target.name] = result;
            }
            else {
                msg[e.target.name] = null;
            }
        }
        else if (e.target.name === 'gstin') {
            let result = GstValidator(e.target.value);
            if (result) {
                msg[e.target.name] = result;
            }
            else {
                msg[e.target.name] = null;
            }
        }
        else if (e.target.name === 'ifsc') {
            let result = IfscValidator(e.target.value);
            if (result) {
                msg[e.target.name] = result;
            }
            else {
                msg[e.target.name] = null;
            }
        }
        else if (e.target.name === 'accountNumber') {
            let result = accountNoValidator(e.target.value);
            if (result) {
                msg[e.target.name] = result;
            }
            else {
                msg[e.target.name] = null;
            }
        }

        setErrorMsg(msg);
    }


    //function to show stepper 1 content
    const stepComp1 = () => {
        return (
            <Grid container spacing={6}>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.shopName ? true : false} required
                            autoComplete="off"
                            helperText={errorMsg.shopName}
                            name="shopName" id="shopName" label="Shop Name"
                            value={userDetails.shopName || ''}
                            onChange={(e) => inputChange(e)}
                            onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.listingName ? true : false} required
                            autoComplete="off"
                            helperText={errorMsg.listingName}
                            name="listingName" id="listingName" label="Listing Name"
                            value={userDetails.listingName || ''}
                            onChange={(e) => inputChange(e)}
                            onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth required error={errorMsg.businessType ? true : false}>
                        <InputLabel id="businessType">Business Type</InputLabel>
                        <Select
                            labelId="businessType"
                            id="businessType"
                            name="businessType"
                            value={userDetails.businessType || ''}
                            onChange={(e) => inputChange(e)}
                            onBlur={(e) => checkValidations(e)}
                            inputProps={{
                                classes: { select: classes.select }
                            }}
                            onClose={() => {
                                setTimeout(() => {
                                    document.activeElement.blur();
                                }, 0);
                            }}
                        >
                            <MenuItem value="Retailer" >Retailer</MenuItem>
                            <MenuItem value="Wholeseller">Wholeseller</MenuItem>

                        </Select>
                        <FormHelperText>{errorMsg.businessType}</FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth required error={errorMsg.category ? true : false} >
                        <InputLabel id="category">Category</InputLabel>
                        <Select
                            required
                            labelId="category"
                            id="category"
                            name="category"
                            value={userDetails.category || ''}
                            onBlur={(e) => checkValidations(e)}
                            onChange={(e) => inputChange(e)}
                            inputProps={{
                                classes: { select: classes.select }
                            }}
                            onClose={() => {
                                setTimeout(() => {
                                    document.activeElement.blur();
                                }, 0);
                            }}
                        >
                            <MenuItem value="TV & Appliances">TV & Appliances</MenuItem>
                            <MenuItem value="Kitchen Appliances">Kitchen Appliances</MenuItem>
                            <MenuItem value="Mobiles">Mobiles</MenuItem>
                            <MenuItem value="Computers">Computers</MenuItem>
                        </Select>
                        <FormHelperText>{errorMsg.category}</FormHelperText>
                    </FormControl>
                </Grid>
            </Grid>
        )
    }

    //function to handle stepper 2 content
    const stepComp2 = () => {
        return (
            <Grid container spacing={6}>
                <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.shopNo ? true : false} type="number" autoComplete="off" helperText={errorMsg.shopNo}
                            required name="shopNo" id="shopNo" label="Shop/Building No" value={userDetails.shopNo || ''}
                            onKeyDown={(evt) => handleTypeNumber(evt)}
                            onChange={(e) => inputChange(e)} onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={9}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.address ? true : false} autoComplete="off" helperText={errorMsg.address}
                            required name="address" id="address" label="Address Line 1" value={userDetails.address || ''} onChange={(e) => inputChange(e)} onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth >
                        <TextField
                            autoComplete="off"
                            name="address2" id="address2" label="Address Line 2" value={userDetails.address2 || ''} onChange={(e) => inputChange(e)} onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={2}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.pincode ? true : false} type="number" autoComplete="off" helperText={errorMsg.pincode}
                            required name="pincode" id="pincode" label="Pincode" value={userDetails.pincode || ''}
                            onKeyDown={(evt) => handleTypeNumber(evt)}
                            onChange={(e) => inputChange(e)} onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.city ? true : false} autoComplete="off" helperText={errorMsg.city}
                            readOnly={userDetails.showCity}
                            disabled={!userDetails.showCity}
                            required name="city" id="city" label="City" value={userDetails.city || ''} onChange={(e) => userDetails.showCity ? inputChange(e) : null} onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.state ? true : false} autoComplete="off" helperText={errorMsg.state}
                            disabled={!userDetails.showState}
                            required name="state" id="state" label="State" value={userDetails.state || ''} onChange={(e) => userDetails.showState ? inputChange(e) : null} onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
            </Grid>
        )
    }

    //function to handle stepper 3 content
    const stepComp3 = () => {
        return (
            <Grid container spacing={6}>
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.pan ? true : false} autoComplete="off" helperText={errorMsg.pan}
                            required name="pan" id="pan" label="PAN No" value={userDetails.pan || ''} onChange={(e) => inputChange(e)} onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.gstin ? true : false} autoComplete="off" helperText={errorMsg.gstin}
                            required name="gstin" id="gstin" label="GSTIN" value={userDetails.gstin || ''} onChange={(e) => inputChange(e)} onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.bankName ? true : false} autoComplete="off" helperText={errorMsg.bankName}
                            required name="bankName" id="bankName" label="Bank Name" value={userDetails.bankName || ''} onChange={(e) => inputChange(e)} onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.accountNumber ? true : false} type="number" autoComplete="off" helperText={errorMsg.accountNumber}
                            required name="accountNumber" id="accountNumber" label="Account Number" value={userDetails.accountNumber || ''}
                            onKeyDown={(evt) => handleTypeNumber(evt)}
                            onChange={(e) => inputChange(e)} onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.ifsc ? true : false} autoComplete="off" helperText={errorMsg.ifsc}
                            required name="ifsc" id="ifsc" label="IFSC Code" value={userDetails.ifsc || ''} onChange={(e) => inputChange(e)} onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth >
                        <TextField
                            error={errorMsg.accountName ? true : false} autoComplete="off" helperText={errorMsg.accountName}
                            required name="accountName" id="accountName" label="Name of account holder" value={userDetails.accountName || ''} onChange={(e) => inputChange(e)} onBlur={(e) => checkValidations(e)} />
                    </FormControl>
                </Grid>

            </Grid>
        )
    }

    //function to handle stepper next 
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    //function to handle stepper back 
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    //function to check form validation
    const checkSubmitValidation = () => {
        if (activeStep === 0) {
            if (errorMsg.shopName || !userDetails.shopName || errorMsg.businessType || !userDetails.businessType || errorMsg.category || !userDetails.category || errorMsg.listingName || !userDetails.listingName) {
                return false
            }
            else {
                return true
            }
        }
        else if (activeStep === 1) {
            if (errorMsg.shopNo || !userDetails.shopNo || errorMsg.address || !userDetails.address || errorMsg.city || !userDetails.city || errorMsg.state || !userDetails.state || errorMsg.pincode || !userDetails.pincode) {
                return false
            }
            else {
                return true
            }
        }
        else if (activeStep === 2) {
            if (errorMsg.pan || !userDetails.pan || errorMsg.gstin || !userDetails.gstin || errorMsg.bankName || !userDetails.bankName || errorMsg.accountNumber || !userDetails.accountNumber || errorMsg.accountName || !userDetails.accountName || errorMsg.ifsc || !userDetails.ifsc) {
                return false
            }
            else {
                return true
            }
        }
    }

    //function to fetch state and city
    const fetchCityState = async (val) => {
        let pincode = val ? val : userDetails.pincode
        await fetchCity(pincode)
            .then(res => {
                if (res && res.data.status === 'success') {
                    setUserDetails({ ...userDetails, city: res.data.city, state: res.data.state, pincode: val, showState: false, showCity: false });
                }
            })
            .catch(error => {
                console.log(error);
            })
    }

    //function to submit registration data
    const submitVal = async () => {
        let reqObj = {
            request_id: JSON.parse(localStorage.getItem('requestId')),
            firm_name: userDetails.shopName,
            listing_name: userDetails.listingName,
            type: userDetails.businessType,
            category: userDetails.category,
            gstin: userDetails.gstin,
            address: userDetails.address,
            address_line_2: userDetails.address2,
            pincode: userDetails.pincode,
            city: userDetails.city,
            state: userDetails.state,
            pan: userDetails.pan,
            bank_name: userDetails.bankName,
            ifsc: userDetails.ifsc,
            account_no: userDetails.accountNumber,
            account_holder_name: userDetails.accountName,
            shopNo: userDetails.shopNo,
            isFinal: activeStep === 2 ? true : false
        }

        await registerUser(reqObj)
            .then(res => {
                if (res && res.data.status === 'success') {
                    if (activeStep !== 2) {
                        handleNext();
                    }
                    else {
                        let error = { ...errorToDisplay };
                        error.msg = 'Thank you for registering as a seller on Gostor. Your account is now under review; you will receive an email upon account activation.';
                        error.title = 'Application Received';
                        error.btn2 = 'Okay';
                        error.path = '/login';
                        setErrorToDisplay(error);
                        setShowModal(true);
                        localStorage.removeItem("requestId");
                    }
                }
                else {
                    let error = { ...errorToDisplay };
                    error.msg = 'Error while submitting data. Please try after some time.';
                    error.title = 'Error';
                    error.btn1 = 'Okay';
                    setErrorToDisplay(error);
                    setShowModal(true);
                }
            })
            .catch(error => {
                console.log(error);
            })
    }

    return (
        <React.Fragment>
            <Grid container >
                <Grid item md={12}>
                    <div className={`${styles.mainWrapper} d-flex justify-content-between`}>
                        <img src="/images/GoStor_main.svg" width="80px" height="auto" />
                        <div>
                            <span>Already registered?</span>
                            <Button variant="outlined" color="primary" className="ml-2" onClick={() => history.replace('/login')} >Login</Button>
                        </div>
                    </div>
                    <Container className={styles.mainContainer}>
                        <Card >
                            <div className={styles.title}>Registration</div>
                            <CardContent className="p-0">
                                <Stepper activeStep={activeStep} alternativeLabel connector={<QontoConnector />} className={styles.stepperBackground} >
                                    {steps.map((label) => (
                                        <Step key={label}>
                                            <StepLabel>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                                <div className={styles.parentContainer} >
                                    <div className={styles.infoText}>
                                        In order to process your registration, we ask you to provide the following information. Please note that all fields
                                        marked with asterisk(*) are required.
                                    </div>
                                    <div className={styles.contentConatiner}>
                                        <Typography>{getStepContent(activeStep)}</Typography>
                                    </div>
                                    <div className={styles.btnContainer}>
                                        {activeStep !== 0 ?
                                            <Button
                                                disabled={activeStep === 0}
                                                onClick={handleBack}
                                                className={styles.prevButton}
                                                boxShadow={2}
                                            >
                                                Back
                                            </Button>
                                            :
                                            null}
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={!checkSubmitValidation()}
                                            className={!checkSubmitValidation() ? styles.disableBtn : null}
                                            onClick={() => checkSubmitValidation() ? submitVal() : null}
                                        >
                                            {activeStep === steps.length - 1 ? 'Register' : 'Save and Proceed'}
                                        </Button>
                                    </div>
                                </div>
                            </CardContent>
                        </Card>
                    </Container>
                </Grid>
            </Grid>
            <ModalComponent
                msg={errorToDisplay.msg}
                title={errorToDisplay.title}
                btn1Text={errorToDisplay.btn1}
                btn2Text={errorToDisplay.btn2}
                show={showModal}
                handleBtn1={() => handleModalClose()}
                handleBtn2={() => history.replace('/login')}
                handleModalClose={handleModalClose} />
        </React.Fragment>
    );
}

export default Registration;